module.exports = __webpack_public_path__ + "static/media/SALSAT_INTRO.fde50251.mp4";